import { axios } from '@/utils/request'

// 获取系统公告列表
export function getSystemNoticeList(params) {
  return axios({
    url: '/distribution/systemNotice',
    method: 'GET',
    params
  })
}

// 获取系统公告明细
export function getSystemNoticeDetail(id) {
  return axios({
    url: '/distribution/systemNotice/' + id,
    method: 'GET',
  })
}

// 获取公告统计
export function getSystemNoticeCount() {
  return axios({
    url: '/distribution/systemNotice/count',
    method: 'GET',
  })
}
